import { render, staticRenderFns } from "./CPUDownload.vue?vue&type=template&id=41dfe940&scoped=true&"
import script from "./CPUDownload.vue?vue&type=script&lang=js&"
export * from "./CPUDownload.vue?vue&type=script&lang=js&"
import style0 from "./CPUDownload.vue?vue&type=style&index=0&id=41dfe940&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dfe940",
  null
  
)

export default component.exports